import { CustomInputScopeSchema } from "@/types/general";
import z from "zod";
import { FollowUpSchema, NoteSchema, DeadlineSchema } from "./zodTypes";

export const ChildSchema = z.object({
  name: z.string().optional(),
  followUpDate: z.string(),
  customInputScopes: z.array(CustomInputScopeSchema).optional(),
  notes: z.array(NoteSchema),
  followUps: z.array(FollowUpSchema),
  deadlines: z.array(DeadlineSchema),
  documents: z.array(z.any()),
});

export const childDefaultValues: z.infer<typeof ChildSchema> = {
  customInputScopes: [],
  notes: [],
  followUps: [],
  deadlines: [],
  followUpDate: new Date().toISOString(),
  documents: [],
};
